import { BASE_STYLES, BASE_SPACING } from './constants.js';
import '../themes/default/borderRadius/index.js';
import '../themes/default/borderWidth/index.js';
import '../themes/default/color/index.js';
import '../themes/default/shape/index.js';
import '../themes/default/size/index.js';
import { SpacingAll } from '../themes/default/spacing/index.js';
import '../theming/themes/caviar.js';
import '../theming/themes/merchant.js';
import '../theming/themes/merchant-next.js';
import '../theming/themes/internal-tools.js';
import '../theming/icons/constants.js';
import '../theming/logo/constants.js';
import '../theming/typography/constants.js';
import 'lodash.clonedeep';
import 'lodash.merge';
import React from 'react';
import { generateShouldForwardPropsConfig } from '@doordash/utilities';
import styled, { css } from 'styled-components';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getSquishedPadding = function getSquishedPadding(props) {
  if (props && props.size && props.isSquished && typeof props.verticalSize === 'undefined') {
    return css(["padding-top:", "px;padding-bottom:", "px;"], props.size / 2, props.size / 2);
  }

  return null;
};

var getStretchedPadding = function getStretchedPadding(props) {
  if (props && props.size && props.isStretched && typeof props.verticalSize === 'undefined') {
    return css(["padding-top:", "px;padding-bottom:", "px;"], props.size * 2, props.size * 2);
  }

  return null;
};

var StyledInset = styled.div.withConfig(generateShouldForwardPropsConfig(['size'])).withConfig({
  displayName: "Inset__StyledInset",
  componentId: "sc-1phi2ey-0"
})(["", " padding:", ";", " ", ""], BASE_STYLES, function (props) {
  return "".concat(typeof props.verticalSize !== 'undefined' && props.verticalSize >= 0 ? props.verticalSize : props.size, "px ").concat(typeof props.horizontalSize !== 'undefined' && props.horizontalSize >= 0 ? props.horizontalSize : props.size, "px");
}, getSquishedPadding, getStretchedPadding); //The complexity of using Static dot notation and ForwardRef w/ TS requires we use this pattern and cast to ensure the Types are accurate.
//https://stackoverflow.com/questions/63453536/jsx-dot-notation-with-forwardref-typescript

var Inset = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? BASE_SPACING : _ref$size,
      _ref$isSquished = _ref.isSquished,
      isSquished = _ref$isSquished === void 0 ? false : _ref$isSquished,
      _ref$isStretched = _ref.isStretched,
      isStretched = _ref$isStretched === void 0 ? false : _ref$isStretched,
      children = _ref.children,
      tag = _ref.tag,
      props = _objectWithoutProperties(_ref, ["size", "isSquished", "isStretched", "children", "tag"]);

  return /*#__PURE__*/React.createElement(StyledInset, _extends({
    ref: ref,
    as: tag,
    size: size,
    isSquished: isSquished,
    isStretched: isStretched
  }, props), children);
});
Inset.Sizes = SpacingAll;
Inset.displayName = 'Inset';

export { Inset, Inset as default };
